import React from "react";

const renderSpotlightContent = (
  field: React.ReactNode,
  codename: string
): React.ReactNode => {
  if (!process.env.GATSBY_USE_PREVIEW) {
    return <>{field}</>;
  }

  return <span data-kontent-element-codename={codename}>{field}</span>;
};

export default renderSpotlightContent;
